module.exports = __webpack_public_path__ + "img/logo_white.527ac4d5.png";